import { DashboardStatistics } from '../models/dashboard-statistics';
import { format } from 'date-fns';
import { ChartData } from 'chart.js';
import { parseServerDateFormat } from '../../../shared/utils/format-date/format-date';

export const dashboardStatisticsToChartData = (
  dashboardStatistics: DashboardStatistics,
  dateFormat?: string,
): ChartData<'line'> => {
  const colors = ['#47b731', '#FF6B00', '#00b0a6', '#cf6cc2', '#ff418e', '#f5d388', '#83cbcb', '#73b8e6', '#ff418e'];
  const labels =
    dashboardStatistics[0]?.dataSet.map(({ date }) => format(new Date(date), parseServerDateFormat(dateFormat))) ?? [];

  const datasets = dashboardStatistics.map((data, index) => {
    const values = data.dataSet.map(({ count }) => Number(count));
    const sum = values.reduce((a, b) => a + b, 0);
    const color = colors[index % colors.length];

    return {
      label: `${data.dataLabel} (${sum})`,
      data: values,
      backgroundColor: color,
      borderColor: color,
      pointStyle: 'circle',
      pointBorderColor: color,
      tension: 0.4,
    };
  });

  return { labels, datasets };
};
